import * as Request from '../../request'
import * as Modal from '../modal'
import * as Actions from './actions'
import * as Types from './types'

type ModalLogoAction = Modal.UpdateFieldAction & Actions.OpenModalAction

export const logoModalReducer = (event: string) =>
  (state: Modal.State<Types.ModalImageData>, action: ModalLogoAction) => {
    switch (action.type) {
      // Overriding default modal actions to close on error
      case Request.errorConstant(event):
        return {
          ...state,
          isOpen: false,
        }
      case Modal.toggleModalConstant(event):
        return {
          ...state,
          data: {
            ...state.data,
            partnerCode: action.partnerCode,
            rowId: action.rowId,
          },
        }
      default:
        return state
    }
 }

export const reducer = <T extends Types.ModalImageData>(event: Modal.ReducerEvent<T>) =>
  Request.reducerChain([
    logoModalReducer(event.requestEvent),
    Modal.reducer(event),
  ])



// WEBPACK FOOTER //
// ./src/components/image/reducer.ts